import React from 'react';
import css from './index.module.scss'

export default () => (
    <section className = {css.section}>
        <div>
            <h2>Get the Comprehensive Weather Information.</h2>
            <p>Data should underlie every business decision. certain routes. Data should be underlie every business decision. Yet too often some very human cultural artifacts really lead the business down the certain routes</p>
        </div>
        <img alt = 'computer' src = {require('./computer.png')} />
    </section>
)